const PT = require("prop-types");
const React = require("react");
const _ = require("lodash");
const createReactClass = require("create-react-class");
const OfficeModal = require("../modals/OfficeModal");
const modalStyles = require("../modals/styles/OfficeModalsGeneral.css");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const EstimateShipping = require("./EstimateShipping");
const ReCAPTCHA = require("react-google-recaptcha").default;
const OpsCart = require("../vault/OpsCart");
const CopyTable = require("../data/CopyTable");

const PaypalButton = require("./PaypalButton");
const withAnimateScroll = require("../../core/hoc/withAnimateScroll");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const AT = require("../../core/vault/ActionTypes");
const ItemSummary = require("../ItemSummary");
const CouponInput = require("./CouponInput");

const styles = require("./styles/OrderSummary.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withAnimateScroll(Component);
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "OrderSummary",

		propTypes: {
			cart: PT.object.isRequired,
			showItemize: PT.bool,
			onContinue: PT.func,
			showError: PT.bool,
			buttonText: PT.oneOfType([PT.string, PT.element]),
			paypalButton: PT.node,
			extraInfo: PT.node,
			hideFinalButtons: PT.bool,
			hidePaypalButton: PT.bool,
			hideCouponEntry: PT.bool,
			buttonContent: PT.element,
			paypalButtonText: PT.string,
			tabIndex: PT.number,
			className: PT.string,
			preventContinue: PT.bool,
			noSticky: PT.bool,
			step: PT.string,
			showCaptcha: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			animateScroll: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				isModalOpen: false,
			};
		},

		onContinue: function(evt) {
			if (this.props.preventContinue) {
				return;
			}
			let captchaUnanswered = false;
			let captchaAnswer = null;
			if (this.captchaRef) {
				captchaAnswer = this.captchaRef.getValue();
				if (!captchaAnswer || captchaAnswer === "") {
					captchaUnanswered = true;
					this.props.dispatch({
						type: AT.SET_CAPTCHA_UNANSWERED,
					});
				} else {
					this.props.dispatch({
						type: AT.SET_CAPTCHA_RESPONSE,
						captchaResponse: captchaAnswer,
					});
				}
			}
			if (!captchaUnanswered) {
				this.props.onContinue && this.props.onContinue();
			}
		},

		onKeyPress: function(evt) {
			if (evt.which === 13) {
				this.onContinue();
			}
		},

		onCancelPaypal: function() {
			this.props.dispatch({
				type: AT.CANCEL_PAYPAL,
			});
		},

		openModal: function() {
			this.setState({isModalOpen: true});
		},

		closeModal: function() {
			this.setState({isModalOpen: false});
		},

		blurContinueButton: function() {
			this.continueButton.blur();
		},

		render: function() {
			const {
				cart,
				showItemize,
				showError,
				hideFinalButtons,
				dispatch,
				preventContinue,
				noSticky,
			} = this.props;
			const {paypalButtonText, tabIndex, className, extraInfo} = this.props;
			const {subtotal, couponApplied, shipping, tax} = cart.prices;
			const shownTotal = OpsCart.getShownTotal(cart);

			const buttonText = this.props.buttonText || "Continue";

			const isEmpty = OpsCart.isEmpty(cart);
			const hasBooks = OpsCart.hasBookItems(cart.items);

			let calculate = null;
			let errors = null;
			if (!showItemize && hasBooks) {
				calculate = (
					<div className={styles.calcOuter}>
						<div className={styles.calculate} onClick={this.openModal}>
							Estimate Shipping
						</div>
					</div>
				);
			}

			if (showItemize && showError) {
				errors = (
					<div className={styles.errors}>
						{"* " + CopyTable.getFormErrorCopy().general}
					</div>
				);
			}

			let modal = null;
			if (this.state.isModalOpen) {
				modal = (
					<OfficeModal
						portalContainer={PORTAL_CONTAINERS.CHECKOUT}
						onClose={this.closeModal}
						modalClass={styles.modal}
						closeClass={modalStyles.closeButtonSmall}
						level="overBar"
					>
						<EstimateShipping cart={cart} />
					</OfficeModal>
				);
			}

			const showCaptcha = !!this.props.showCaptcha;
			const captchaButton = showCaptcha ? (
				<ReCAPTCHA
					sitekey={window.BA_RECAPTCHA_SITE_KEY}
					ref={r => (this.captchaRef = r)}
				/>
			) : null;

			let button = null;
			let couponInput = null;

			if (!isEmpty && !hideFinalButtons) {
				const continueClassName = preventContinue
					? `${styles.continue} ${styles.continueDisabled}`
					: styles.continue;
				button = (
					<div className={styles.buttonContainer}>
						{errors}
						<div
							className={continueClassName}
							ref={b => (this.continueButton = b)}
							onContextMenu={this.blurContinueButton}
							onClick={this.onContinue}
							tabIndex={preventContinue ? -1 : tabIndex}
							onKeyPress={this.onKeyPress}
							aria-disabled={preventContinue}
						>
							{buttonText}
						</div>
					</div>
				);

				couponInput = (
					<CouponInput
						couponInfo={OpsCart.getCouponInfo(cart)}
						dispatch={dispatch}
					/>
				);

				if (OpsCart.hasOnlySubscriptionCodeItems(cart.items)) {
					couponInput = null;
				}
			} else if (this.props.buttonContent) {
				button = (
					<div className={styles.buttonContainer}>
						{errors}
						{this.props.buttonContent}
					</div>
				);
			}

			let paypalButton;
			const paypalText = paypalButtonText;

			if (paypalText && OpsCart.isPaypalAvailable(cart) && !preventContinue) {
				if (cart.onPaypalFlow) {
					paypalButton = (
						<div className={styles.quitPaypalContainer}>
							<div
								className={styles.quitPaypal}
								onClick={() => this.onCancelPaypal()}
							>
								Cancel PayPal
							</div>
						</div>
					);
				} else {
					paypalButton = (
						<PaypalButton paymentID={cart.paypalPaymentID} text={paypalText} />
					);
				}
			}

			let mainClass = noSticky ? styles.main : styles.mainSticky;
			if (className) {
				mainClass += " " + className;
			} else {
				mainClass += " " + styles.mainDefault;
			}

			let couponExtraInfo = {};
			let couponCopy;
			const couponCode = OpsCart.getCouponCode(cart);
			if (couponCode && OpsCart.hasSubscriptionItems(cart.items)) {
				couponExtraInfo = OpsCart.getCouponExtraInfo(cart) || {};
				const remainingBalance = couponExtraInfo.remainingBalance;
				if (remainingBalance && remainingBalance.gt(0)) {
					couponCopy = (
						<div className={styles.couponCopy}>
							{CopyTable.getCouponExtraCopy(
								couponApplied,
								remainingBalance.toFixed(2)
							)}
						</div>
					);
				}
			}

			const shippingCountry = _.get(cart, "form.data.shipping.country");
			const billingCountry = _.get(cart, "form.data.billing.country");
			const isInternational =
				(shippingCountry && shippingCountry !== "US") ||
				(billingCountry && billingCountry !== "US");
			const exchangeRatesNotice = CopyTable.getExchangeRatesMessageForOrder(
				styles,
				isInternational
			);

			return (
				<div className={mainClass}>
					<div className={styles.title}>{"Order Summary"}</div>
					{extraInfo}
					<div className={styles.content}>
						<ItemSummary
							items={cart.items}
							couponCode={couponCode}
							total={shownTotal}
							subtotal={subtotal}
							couponApplied={couponApplied}
							tax={tax}
							shipping={shipping}
							showItemize={showItemize}
							couponExtraInfo={couponExtraInfo}
							isInternational={isInternational}
						/>
						{exchangeRatesNotice}
						{this.props.hideCouponEntry ? null : couponInput}
						{this.props.hideCouponEntry ? null : couponCopy}
						{captchaButton}
						{button}
						{this.props.hidePaypalButton ? null : paypalButton}
						{calculate}
					</div>
					{modal}
				</div>
			);
		},
	})
);
